import React from "react";
import cx from "classnames";
import styles from "../../styles/DigikalaGroupPage.module.css";
import Head from "next/head";
import BreadcrumbScroll from "../../components/Elements/BreadcrumbScroll/BreadcrumbScroll";
import digikalaGroupImage from "../../images/digikalaGroupImage.svg";
import Image from "next/image";

const DigikalaGroupPage = () => {
  return (
    <>
      <Head>
        <title>گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا</title>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width, maximum-scale=1"
        />
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="دیجی‌کالا (نوآوران فن‌آوازه) در سال 1385 با سرمایه اولیه بسیار محدود به عنوان پلتفرم خرده فروشی آنلاین آغاز به کار کرد"
        />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link
          rel="canonical"
          href={`https://about.digikala.com/digikala-group/`}
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا"
        />
        <meta
          property="og:url"
          content={`https://about.digikala.com/digikala-group/`}
        />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" itemProp="image" content="/ogImage.jpg" />
        <meta property="og:image:width" content="500" />
        <meta property="og:image:height" content="500" />
        <meta
          property="og:image:alt"
          content="گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا"
        />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content="گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا"
          key="ogtitle"
        />
        <meta
          property="og:description"
          content="دیجی‌کالا (نوآوران فن‌آوازه) در سال 1385 با سرمایه اولیه بسیار محدود به عنوان پلتفرم خرده فروشی آنلاین آغاز به کار کرد"
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="گروه تجارت الکترونیک دیجی‌کالا - درباره گروه دیجی‌کالا"
        />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogImage.jpg"
        />
        <meta
          name="twitter:description"
          content="دیجی‌کالا (نوآوران فن‌آوازه) در سال 1385 با سرمایه اولیه بسیار محدود به عنوان پلتفرم خرده فروشی آنلاین آغاز به کار کرد"
        />
      </Head>
      <BreadcrumbScroll
        title="گروه تجارت الکترونیک دیجی‌کالا"
        routeOne="/digikala-group"
        titleOne="گروه تجارت الکترونیک دیجی‌کالا"
      />
      <div className="breadCrumbSpacer"></div>
      <h1 className={cx(styles.pageTitle, "text-center", "w-100", "my-5")}>
        گروه تجارت الکترونیک دیجی‌کالا
      </h1>
      <div className="container">
        <p className={cx(styles.paragraph)}>
          دیجی‌کالا (نوآوران فن‌آوازه) در سال ۱۳۸۵ با سرمایه اولیه بسیار محدود
          به عنوان پلتفرم خرده فروشی آنلاین آغاز به کار کرد و در طول ۱۶ سال با
          ورود به مدل‌های کسب‌وکار جدید، فراتر از یک شرکت خرده فروشی آنلاین عمل
          کرد و اکوسیستم تجارت الکترونیک خود را در قالب گروه دیجی‌کالا توسعه
          داد. تا اواسط سال ۱۴۰۰، دیجی‌کالا به‌عنوان بزرگترین شرکت عملیاتی گروه،
          در جایگاه شرکت هلدینگ نیز فعالیت می‌کرد و سایر شرکت‌های عملیاتی گروه
          که در مراحل مختلف رشد قرار داشتند زیر مجموعه این شرکت بودند.
        </p>
        <p className={cx(styles.paragraph)}>
          در تیر ماه ۱۴۰۰ شرکت گروه تجارت الکترونیک دیجی‌کالا فعالیت رسمی خود را
          با نقش هدف‌گذاری، راهنمایی و نظارت راهبردی و نیز کنترل مالی بر
          شرکت‌های گروه آغاز کرد و مالکیت تمام شرکت‌های عملیاتی به شرکت گروه
          تجارت الکترونیک دیجی‌کالا منتقل شد. اکنون شرکت‌های زیر مجموعه گروه
          تجارت الکترونیک دیجی‌کالا شامل دیجی‌کالا، فیدیبو، دیجی‌پی، اسمارتک،
          دیجی‌نکست، دیجی‌فای، دیجی‌اکسپرس، دیجی‌کالا جت، پیندو، گنجه، آپتایم
          هستند.
        </p>
        <p className={cx(styles.paragraph)}>
          اکنون کل سهام فروشگاه اینترنتی دیجی‌کالا (نوآوران فن آوازه)، متعلق به
          گروه تجارت الکترونیک دیجی‌کالاست.
        </p>
        <p className={cx(styles.paragraph)}>
          در ترکیب هیئت مدیره گروه تجارت الکترونیک دیجی‌کالا محمد مهدی عباسخانی
          در مقام رئیس هیئت مدیره، سعید محمدی به عنوان مدیرعامل و عضو هیئت
          مدیره، حمید محمدی در مقام نائب رئیس هیئت مدیره، سید عباس نوربخش و علی
          فیاض بخش به عنوان اعضای هیئت مدیره فعالیت می‌کنند.
        </p>
        <h2 className={cx(styles.heading2, "text-center", "w-100", "my-5")}>
          شرکت‌های گروه تجارت الکترونیک دیجی‌کالا
        </h2>
        <Image
          src={digikalaGroupImage}
          alt="شرکت‌های گروه تجارت الکترونیک دیجی‌کالا"
          className={styles.digikalaGroupImage}
        />
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌کالا؛ فروشگاه اینترنتی عمومی کالا (شروع فعالیت: 85)
        </h3>
        <p className={styles.paragraph}>
          دیجی‌کالا پلتفرمی مبتنی بر تکنولوژیست که مأموریت دارد تجربه‌ای خوشایند
          از خرید و فروش را برای تمام مردم ایران، به وسیله ایجاد دسترسی به طیف
          گسترده‌ای از کالاها، خدمات و امکانات با بهترین قیمت و کامل‌ترین
          اطلاعات، فراهم کند. دیجی‌کالا امروز پربازدیدترین فروشگاه آنلاین ایران
          است که ارائه خدمات منطبق با استانداردهای جهانی را یکی از مهمترین وظایف
          خود می‌داند. دیجی‌کالا از همان ابتدا تمرکز خود را بر «مشتری‌محوری»
          به‌عنوان مهمترین ارزش کسب‌وکار قرار داد. شفافیت، نوآفرینی، چابکی و
          مسئولیت‌پذیری از دیگر ارزش‌های محوری دیجی‌کالا هستند.
        </p>

        <ul className="mb-5">
          <li>
            <p className="paragraphStaticPages">
              دیجی‌استایل (فروشگاه اینترنتی پوشاک)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              پیندو (بازار آنلاین خرید و فروش کالا و خدمات)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              مگنت (پلتفرم بررسی و انتخاب کالا)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌کالا بیزینس (راهکارهای هوشمند برای خریدهای سازمانی)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌کالا مگ و کارخانه محتوا (سرویس‌های مرتبط با بازاریابی محتوایی
              و تولید محتوا)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌پلاس (سرویس اشتراک ویژه مشتریان)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌کالا سرویس (سرویس ارائه خدمات پس از فروش)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌کلاود (سرویس مبتنی بر فناوری ابری)،
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              دیجی‌کالا مهر (پلتفرم نیکوکاری)
            </p>
          </li>
          <li>
            <p className="paragraphStaticPages">
              بومی و محلی (پروژه توانمندسازی کسب‌وکارهای خانگی و روستایی)
            </p>
          </li>
        </ul>
        <p className={styles.paragraph}>
          از جمله سرویس‌های اصلی بزرگترین شرکت عملیاتی گروه یعنی دیجی‌کالا
          هستند. دیجی‌کالا اکنون یکی از بزرگترین مراکز پردازش سفارش‌ها را در
          ایران و منطقه در اختیار دارد.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          فیدیبو؛ پلتفرم محتوای دیجیتال (شروع فعالیت: 95)
        </h3>
        <p className={cx(styles.paragraph)}>
          فیدیبو اولین و پرمخاطب‌ترین بستر ارائه کتاب صوتی و الکترونیکی‌ست که با
          تکیه بر اعتماد بازار نشر، توانسته آنچه نیاز محتوای فرهنگی مخاطب در
          بخش‌ها و سبک‌های مختلف است را در کنار هم گردآوری کرده و فرصت زندگی
          مدرن همراه با کتاب‌خوانی را بیش از گذشته برای مخاطب فراهم سازد.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌پی؛ پلتفرم خدمات پرداخت هوشمند (شروع فعالیت: 97)
        </h3>
        <p className={cx(styles.paragraph)}>
          ارائه اعتبارهای خرد و خدمات متنوع مالی با تکیه بر فناوری، تمرکز
          دیجی‌پی برای تحقق هدف فراگیری مالی است. دیجی‌پی تاکنون سرویس‌های
          اعتباری، درگاه پرداخت هوشمند، کیف پول و سرویس بازگشت وجهِ کالاهای
          مرجوعی را به کاربران نهایی، و خدمات تامین مالی زنجیره تامین را به
          فروشندگان و تامین‌کنندگان دیجی‌کالا، ارائه کرده است.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌نکست؛ مرکز نوآوری و سرمایه‌گذاری (شروع فعالیت: 97)
        </h3>
        <p className={cx(styles.paragraph)}>
          دیجی‌نکست با تمرکز بر زنجیره ارزش تجارت الکترونیک و تکنولوژی‌های روز
          در چهار حوزه تزریق سرمایه به کسب‌و‌کارهای نوپا، برنامه‌های توسعه
          موضوعات تکنولوژی محور، برنامه‌های شتابدهی و پیش شتابدهی و برنامه‌های
          آموزشی فعالیت می‌کند.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          اسمارتک؛ بستر راهکارهای تکنولوژی بازاریابی (شروع فعالیت: 98)
        </h3>
        <p className={cx(styles.paragraph)}>
          کمک به کسب‌وکارها برای شناخت بهتر مشتریان و بهبود اثربخشی تعاملات از
          طریق فناوری بازاریابی، بنیان فعالیت‌های اسمارتک است. اتوماسیون
          بازاریابی، شبکه تبلیغات هوشمند، سیستم همکاری در فروش، پلتفرم داده‌های
          مشتریان، از سرویس‌هایی هستند که اسمارتک به کسب‌وکارها ارائه میدهد.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌اکسپرس؛ زیرساخت و شبکه هوشمند لجستیکی (شروع فعالیت: 99)
        </h3>
        <p className={cx(styles.paragraph)}>
          دیجی‌اکسپرس با توسعه پلتفرم‌های تکنولوژی‌محور، خدمات لجستیکی در
          حوزه‌های جمع‌آوری، پردازش، توزیع و تحویل را به شرکت‌ها، فروشندگان
          آنلاین و آفلاین و خریداران و مصرف کنندگان نهایی ارائه می‌دهد Flex و
          Jet دو سرویس ارسال مستقیم و در لحظه دیجی‌اکسپرس هستند.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          آپتایم؛ سامانه مدیریت ناوگان مبتنی بر هوش مصنوعی (شروع فعالیت: 99)
        </h3>
        <p className={cx(styles.paragraph)}>
          هدف آپتایم از ارائه خدمات به کسب‌وکارهای مختلف، بهینه‌سازی هوشمند
          فرایند تحویل کالا و مدیریت شفاف ناوگان حمل‌ونقل است. آپتایم مدیریت
          ناوگان را به صورت خودکار انجام می‌دهد و از هوش مصنوعی برای پیشنهاد
          مسیر بهینه‌تر استفاده می‌کند.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          پیندو؛ بازار آنلاین خرید و فروش کالا و ارائه خدمات (شروع فعالیت: 99)
        </h3>
        <p className={cx(styles.paragraph)}>
          پیندو بازار آنلاین خرید و فروش کالا و ارائه خدمات است. پیندو با وصل
          کردن مستقیم خریدار و فروشنده تجربه خرید بهتری را برای هردو رقم می‌زند
          یکی از آن‌ها فروش بدون کمیسیون و خرید با قیمت پایین‌تر است. قالب
          فروشنده‌های پیندو را کسب‌وکار‌های کوچک و متوسط تشکیل می‌دهند.
          فروشنده‌های پیندو ‌می‌توانند با وصل کردن کالاهای‌ خود به دیجی‌کالا
          بازدید از کالا را افزایش دهند و فروش بیشتری داشته باشند. پیندو همچنین
          با معامله امن، امنیت و آسایش در خرید را برای کاربران خود فراهم کرده
          است.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌فای؛ ارائه‌دهنده راهکارهای جامع برای کسب‌وکارهای اینترنتی (شروع
          فعالیت: 1400)
        </h3>
        <p className={cx(styles.paragraph)}>
          توسعه کسب‌وکارهای خُرد و مستقل، تمرکز دیجی‌فای در ارائه خدمات
          فروشگاه‌سازی آنلاین است. دیجی‌فای در زمینه‌های بازاریابی، لجستیک،
          پرداخت، باشگاه مشتریان، و خدمات پس از فروش نیز به رشد کسب‌وکارهای کوچک
          و متوسط حضوری و آنلاین کمک می‌کند. با استفاده از فروشگاه‎ساز آنلاین
          دیجی‌فای یک کسب‌وکار می‌تواند فروشگاه اختصاصی خودش را داشته باشد.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          گنجه؛ زیرساخت فناوری‌محور لجستیکی (شروع فعالیت: 1400)
        </h3>
        <p className={cx(styles.paragraph)}>
          گنجه یک قفسه هوشمند مبتنی بر اینترنت اشیا است که به مشتریان امکان می
          دهد تا بسته‌های خود را در مکان و زمان مناسب، بدون تعامل انسانی تحویل
          بگیرند. این انبارهای کوچک، عملیات توزیع و نگهداری مرسوله‌ها را انجام
          می‌دهند و باعث کاهش هزینه‌های لجستیکی می‌شوند.
        </p>
        <h3 className={cx(styles.heading3, "w-100", "my-3")}>
          دیجی‌کالا جت؛ پلتفرم خرید آنلاین و فوری محصولات سوپرمارکتی (شروع
          فعالیت: 1400)
        </h3>
        <p className={cx(styles.paragraph)}>
          چشم‌انداز دیجی‌کالا جت برآورده کردن نیازهای مشتری در سریع‌ترین زمان
          ممکن و ایجاد یک تجربه خرید به‌صرفه، کاربردی و راحت است. تامین محصولات
          دیجی‌کالا جت به دو روش همکاری با فروشگاه‌‌های معتبر و فروشگاه‌‌های
          اختصاصی «جت مارت» انجام می‌شود.
        </p>
      </div>
      {/*<div className={cx(styles.imageWrapper, "d-flex", "mx-auto")}>*/}
      {/*    <Image unoptimized src="https://about.digikala.com/wp-content/uploads/2022/11/Sazmani-1-2048x1229.jpg" width={100} height={100} alt="گروه تجارت الکترونیک دیجی‌کالا" />*/}
      {/*</div>*/}
    </>
  );
};

export default DigikalaGroupPage;
